import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareService } from '../share-service';
import { ShareIdRepository, EmailInviteRepository } from '../../services/share-tools-repository';
import type { InviteByEmailData, ShareAuthCheckData } from '../../types';
import { Message } from '@patsnap/tahiti-core/common/message';
import { BiTrackService } from '@eureka/domains/src/bi-track/services/bi-track-service';
import { EurekaTrackEventType } from '@eureka/domains/src/bi-track/types';
import { ShareI18nService } from '../share-i18n-service';
import { AuthModel } from '../../models/auth.model';

@injectable()
export class ShareServiceImpl implements ShareService {
    constructor(
        @inject(ShareIdRepository) private shareIdRepository: ShareIdRepository,
        @inject(EmailInviteRepository) private emailInviteRepository: EmailInviteRepository,
        @inject(AuthModel) private _authModel: AuthModel,
        @inject(Message) private _message: Message,
        @inject(ShareI18nService) private _i18nService: ShareI18nService,
        @inject(BiTrackService) private _biTrackService: BiTrackService
    ) {
    }

    getShareId(data: ShareAuthCheckData) {
        const isGuest = !this._authModel.modelData.isLogin
        return isGuest ? this.shareIdRepository.getShareIdForGuest(data) : this.shareIdRepository.getShareId(data)
    }

    inviteByEmail(data: InviteByEmailData) {
        return this.emailInviteRepository.inviteByEmail(data).then(() => {
            this._message.success({
                message: this._i18nService.t('airShareDialog.emailSuccess'),
            });
            this._biTrackService.biTrack(EurekaTrackEventType.SHARE_INFO, {
                sourceType: 'invite-by-email',
                otherParam: data.from,
                eventDetailStr: {
                    id: data.share_id,
                    email: data.share_emails[0],
                },
            });
        });
    }

    createLSShareId(data: Parameters<ShareIdRepository['getPDAShareId']>[0]) {
        return this.shareIdRepository.getPDAShareId(data);
    }

    sendPDAShareByEmail(data: Parameters<ShareIdRepository['sendPDAShareByEmail']>[0]) {
        return this.shareIdRepository.sendPDAShareByEmail(data);
    }
}
